/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_get_comfy_lean_back_and_learn_about_ancient_wisdom_of_yoga_with_our_docs_and_films: Phrase =locale => {
  const en = `Get comfy, lean back and learn about the ancient wisdom of yoga with our docs and films.`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Ponte cómodo, relájate y aprende sobre la antigua sabiduría del yoga con nuestros documentales y películas.`,
  };
  return phrases[locale] || en;
};
            